/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const DefaultPlanType = 'ST';
export const planTypeMedicaid = 'Medicaid';
export const radioGroupLabelName = 'Plan Type';
export const rebateProgramLabelName = 'Rebate Program';
export const lemplateTypeName = 'Template Type';
export const actionList = [
  { name: 'Open Existing', value: 'Open_Existing' },
  { name: 'Create New', value: 'Create_New' },
];
export const openExisting = 'Open_Existing';
export const createNew = 'Create_New';
export const freeFromText = 'Free Form Text';
export const codeDomainList = ['PLAN_TYPE_CD', 'TEMPLATE_TYPE_CD'];
export const coverTemplate = 'COVER';
export const disputeTemplate = 'DISPUTE';
export const collectTemplate = 'COLLECT';
export const actionTypeUpdate = 'Update';
export const actionTypeAdd = 'Add';
export const pastDueInvoiceData = 'Past Due Invoice Data';
export const disputesNDCDetail = 'Disputes - NDC Detail';
export const gridType = 'GRID';
/** Merge fields that use selection-sequence Display Order (Body & Header/Footer). */
export const dynamicDisplayOrderMergeFields = [
  'Labelers',
  'Labeler',
  'Invoice Header',
  'Totals Section',
  'Total Section',
  'Selected Qtr Invoice Fields',
  'Past Due Invoice Data',
];
export const isDynamicDisplayOrderMergeField = (description) =>
  dynamicDisplayOrderMergeFields.includes(description);
/** Page number token is valid in Header/Footer only — hide it from Body Add Merge Fields. */
export const pageNumberMergeField = 'Page # of #';
export const isPageNumberMergeField = (description) =>
  description === pageNumberMergeField;
export const isPageNumberDisplayName = (name = '') =>
  String(name).replace(/[0-9]/g, '') === pageNumberMergeField;
export const htmlHasPageNumberMergeField = (html = '') =>
  /\{Page # of #\d*\}/.test(html) ||
  String(html).includes(pageNumberMergeField);
/** Backend strips `{Page # of #n}`; save unbraced text so Preview can render it. */
export const toPreviewSafePageNumberHtml = (html = '') => {
  if (!html) return html;
  return html.replace(/\{Page # of #\d*\}/g, pageNumberMergeField);
};
export const contactAddress = '{CONTACT ADDRESS';
export const contactAddressExists =
  'Contact Address Merge Field already exists';
export const maintainLetterTemplate = 'Maintain letter template';
export const windowAddressIndicatorError =
  'Window Address indicator needs to be turned off, before Contact Address Merge Field can be inserted.';
export const selectMergeFieldOptionsError = 'Select Merge Field Options';
export const mergeFieldError =
  'This type of Merge Field is Not allow in the Header/Footer section. Please put this in the Body section instead.';
